<template>
  <layoutContainer>
    <div class="faq-container">
      <!-- 页面头部 -->
      <!-- <div class="faq-header">
      <div class="header-content">
        <div class="back-btn" @click="goBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <h1 class="page-title">常见问题</h1>
      </div>
    </div> -->

      <!-- 主要内容区域 -->
      <div class="faq-main">
        <!-- 左侧分类导航 -->
        <div class="faq-sidebar">
          <!-- <div class="sidebar-header">
            <h3>问题分类</h3>
          </div> -->
          <div class="category-list">
            <!-- 加载状态 -->
            <!-- <div v-if="categoryLoading" class="loading-state">
              <i class="el-icon-loading"></i>
              <span>加载分类中...</span>
            </div> -->

            <!-- 分类列表 -->
            <template>
              <div
                class="category-item title"
              >
                <span class="category-label">常见问题 {{ this.$route.query.tag }}</span>
              </div>
              <!-- 全部分类 -->
              <div
                class="category-item"
                :class="{active: activeCategory === 'all'}"
                @click="handleCategoryChange('all')"
              >
                <span class="category-label">全部</span>
              </div>
              <!-- 具体分类 -->
              <div
                v-for="category in categoryList"
                :key="category.classId"
                class="category-item"
                :class="{active: activeCategory === category.classId.toString()}"
                @click="handleCategoryChange(category.classId.toString())"
              >
                <span class="category-label">{{ category.className }}</span>
              </div>
            </template>
          </div>
        </div>

        <!-- 右侧内容区域 -->
        <div class="faq-content">
          <!-- 问题列表 -->
          <div class="faq-list">
            <!-- 加载状态 -->
            <div v-if="loading" class="loading-state">
              <i class="el-icon-loading"></i>
              <span>加载问题中...</span>
            </div>

            <!-- 问题列表 -->
            <div v-else class="question-list">
              <div v-for="item in filteredFaqList" :key="item.id" class="question-item">
                <div class="question-header">
                  <h4 class="question-title"><img class="img" src="/img/qa-icon.png"/>{{ item.question }}</h4>
                  <!-- <span class="category-tag" :class="getCategoryClass(item.classId)">
                    {{ getCategoryLabelByClassId(item.classId) }}
                  </span> -->
                </div>
                <div class="question-content">
                  <div class="answer-text" v-html="item.answer"></div>
                </div>
              </div>
            </div>

            <!-- 没有找到相关问题 -->
            <div v-if="!loading && filteredFaqList.length === 0" class="no-result">
              <div class="no-result-icon">📝</div>
              <div class="no-result-text">暂无相关问题</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layoutContainer>
</template>

<script>
import {getFaqList, getCategoryConfig} from '../../api/faq'

export default {
  name: 'FaqPage',
  data() {
    return {
      activeCategory: 'all',
      faqList: [],
      categoryList: [], // 存储分类列表数据
      loading: false,
      categoryLoading: false,
      isUserClick: false // 标记是否为用户点击切换
    }
  },
  async created() {
    // 滚动到顶部
    window.scrollTo(0, 0)
    // 初始化分类配置
    await this.initCategoryConfig()
    // 根据URL参数设置选中的分类
    this.setActiveCategoryFromUrl()
  },
  computed: {
    // 过滤后的问题列表
    filteredFaqList() {
      return this.faqList
    }
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1)
    },

    // 处理分类切换
    async handleCategoryChange(category) {
      this.activeCategory = category
      this.isUserClick = true // 标记为用户点击
      // 重新加载问题列表
      await this.loadFaqList()
    },

    // 根据URL参数设置选中的分类
    setActiveCategoryFromUrl() {
      const urlClassName = this.$route.query.className
      if (urlClassName && this.categoryList.length > 0) {
        // 根据className找到对应的classId
        const category = this.categoryList.find(item => item.className === urlClassName)
        if (category) {
          this.activeCategory = category.classId.toString()
        }
      }
    },

    // 初始化分类配置
    async initCategoryConfig() {
      this.categoryLoading = true
      try {
        // 代码优化，咨询参数，取url上的tag参数
        const tag = this.$route.query.tag || '咨询'
        const response = await getCategoryConfig(tag)
        // 根据新的接口响应格式处理数据
        if (response && response.data) {
          this.categoryList = response.data
        } else {
          this.categoryList = []
        }
        // 初始化完成后加载问题列表
        await this.loadFaqList()
      } catch (error) {
        console.error('初始化分类配置失败:', error)
        this.$message.error('加载分类失败，请刷新页面重试')
        this.categoryList = []
      } finally {
        this.categoryLoading = false
      }
    },

    // 加载问题列表
    async loadFaqList() {
      this.loading = true
      try {
        let className = ''

        // 如果是用户点击切换，优先使用点击的分类
        if (this.isUserClick && this.activeCategory !== 'all') {
          const category = this.categoryList.find(item => item.classId.toString() === this.activeCategory)
          className = category ? category.className : ''
        } else if (!this.isUserClick && this.$route.query.className) {
          // 如果不是用户点击，且URL中有className参数，使用URL参数
          className = this.$route.query.className
        } else if (this.activeCategory !== 'all') {
          // 其他情况使用当前选中的分类
          const category = this.categoryList.find(item => item.classId.toString() === this.activeCategory)
          className = category ? category.className : ''
        }

        const response = await getFaqList({
          className: className,
          tag: this.$route.query.tag || '咨询'
        })

        // 根据新的接口响应格式处理数据
        if (response && response.data) {
          this.faqList = response.data
        } else {
          this.faqList = []
        }
      } catch (error) {
        console.error('加载问题列表失败:', error)
        this.$message.error('加载问题列表失败，请重试')
        this.faqList = []
      } finally {
        this.loading = false
        this.isUserClick = false // 重置用户点击标志
      }
    },

    // 根据classId获取分类标签
    getCategoryLabelByClassId(classId) {
      const category = this.categoryList.find(item => item.classId === classId)
      return category ? category.className : '其他'
    },

    // 根据classId获取分类样式类
    getCategoryClass(classId) {
      // 直接使用classId作为样式类名
      return classId ? classId.toString() : 'other'
    }
  }
}
</script>

<style lang="scss" scoped>
.faq-container {
  height: 98vh;
}

.faq-header {
  background: #ffffff;
  padding: 20px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;

  .header-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
  }

  .back-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #666;
    font-size: 16px;
    margin-right: 20px;

    i {
      margin-right: 5px;
      font-size: 18px;
    }

    &:hover {
      color: #5ad3cd;
    }
  }

  .page-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }
}

.faq-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  gap: 20px;
  height: 100%;
  margin-top: 30px;
}

.faq-sidebar {
  // background: #ffffff;
  // border-radius: 8px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  // height: fit-content;
  top: 100px;

  .sidebar-header {
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
  }

  .category-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;

    .loading-state {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      color: #666;
      font-size: 14px;

      i {
        margin-right: 8px;
        font-size: 16px;
      }
    }

    .category-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 165px;
      height: 49px;
      // background: #eeeeee;
      border-radius: 8px;
      cursor: pointer;
      // transition: all 0.3s ease;
      margin-bottom: 12px;
      color: #999;
      // color: #999999;
      &.title {
        background: #5AD3CD;
        font-weight: bold;
        color: #ffffff;
      }

      // &:hover {
      //   background: #EEEEEE;
      // }

      &.active {
        background: #EEEEEE;
        font-weight: bold;
        color: #333333;

        .category-label {
          font-weight: 600;
        }
      }

      .category-label {
        font-size: 18px;
        // color: #333;
        // transition: all 0.3s ease;
        // font-weight: 500;
      }
    }
  }
}

.faq-content {
  flex: 1;
  background: #ffffff;
  border-radius: 8px;
  padding: 17px 24px;
  margin-top: 10px;
  height: calc(100vh -100px);
}

.faq-list {
  .loading-state {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #666;
    font-size: 14px;

    i {
      margin-right: 8px;
      font-size: 16px;
    }
  }

  .question-list {
    .question-item {
      margin-bottom: 32px;
      // padding: 0  20px;
      // padding-bottom: 0px;
      // border: 1px solid #f0f0f0;
      // border-radius: 8px;
      // background: #fafafa;

      &:last-child {
        margin-bottom: 0;
      }

      .question-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 12px;

        .question-title {
          flex: 1;
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #5AD3CD;
          line-height: 1.4;
          margin-right: 12px;
          display: flex;
          align-items: center;
          .img {
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }
        }

        .category-tag {
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;
          flex-shrink: 0;

          // 修改资料
          &.1 {
            background: #e6f7ff;
            color: #1890ff;
          }

          // 退款
          &.2 {
            background: #fff1f0;
            color: #f5222d;
          }

          // 金额消耗
          &.3 {
            background: #fff7e6;
            color: #fa8c16;
          }

          // 收入
          &.4 {
            background: #f6ffed;
            color: #52c41a;
          }

          // 默认样式
          &.other {
            background: #f5f5f5;
            color: #666;
          }
        }
      }

      .question-content {
        margin-left: 32px;
        .answer-text {
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          line-height: 1.6;
        }
      }
    }
  }

  .no-result {
    text-align: center;
    padding: 60px 20px;
    background: #f8f9fa;
    border-radius: 8px;
    margin: 20px 0;

    .no-result-icon {
      font-size: 48px;
      margin-bottom: 20px;
    }

    .no-result-text {
      font-size: 16px;
      color: #666;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .faq-main {
    flex-direction: column;
    padding: 15px;
  }

  .faq-sidebar {
    width: 100%;
    margin-bottom: 20px;

    .category-list {
      display: flex;
      overflow-x: auto;
      padding: 10px;
      gap: 12px;

      .category-item {
        flex-shrink: 0;
        white-space: nowrap;
        width: 140px;
        height: 40px;
        margin-bottom: 0;

        .category-label {
          font-size: 16px;
        }
      }
    }
  }

  .faq-content {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .faq-header {
    .header-content {
      padding: 0 15px;
    }

    .page-title {
      font-size: 20px;
    }
  }

  .faq-sidebar {
    .category-list {
      .category-item {
        width: 120px;
        height: 36px;
        font-size: 14px;

        .category-label {
          font-size: 14px;
        }
      }
    }
  }

  .faq-list {
    .question-list {
      .question-item {
        padding: 15px;
        margin-bottom: 16px;

        .question-header {
          flex-direction: column;
          align-items: flex-start;

          .question-title {
            margin-right: 0;
            margin-bottom: 8px;
          }
        }
      }
    }
  }
}
</style>
